@use "../../../globals/settings";
@use "../../../globals/bcp-2022/objects/flyouts";
@use "../../../globals/bcp";

$self: ".f-flyout";

:host {
  @include bcp.decl(flyout-tip, right, 0.5rem, true);
  @include bcp.decl(flyout-container, top, 6rem, true);
  @include bcp.decl(flyout-container, right, 0, true);
}

.f-flyout {
  @include flyouts.flyout();

  &.is-opening {
    @include flyouts.is-showing();
  }

  &.is-open {
    @include flyouts.show();
  }

  &__inner {
    @include flyouts.with-arrow();
  }

  &__box {
    @include flyouts.box();
  }

  &__header {
    @include flyouts.header();
  }

  &__heading {
    @include flyouts.heading();
  }

  &__close {
    position: relative;
    right: -12px;
  }

  &__content {
    @include flyouts.content();
    @include flyouts.content-part;
  }

  &__footer {
    @include flyouts.footer();
  }

  &--only-content {
    .f-flyout {
      &__box {
        min-height: initial;
        grid-template-columns: 1fr auto;
        grid-template-rows: 1fr;
        grid-template-areas: "content header";
      }

      &__header {
        padding-left: 0;
        align-items: flex-start;
      }
    }
  }
}

::slotted(.content-full) {
  @include flyouts.content-full;
}

::slotted(.content-part) {
  @include flyouts.content-part;
}

::slotted([slot="flyout-feature-bar"]:empty) {
  display: none;
}

:host(.only-content) {
  @include bcp.decl(flyout-content, padding-left, 0, true);
  @include bcp.decl(flyout-content, padding-right, 0, true);
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
